import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import { http } from './http';

var AnalyticsService = /*#__PURE__*/function () {
  function AnalyticsService() {
    _classCallCheck(this, AnalyticsService);
  }

  _createClass(AnalyticsService, [{
    key: "getEventStats",
    value: function () {
      var _getEventStats = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(serviceId, payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return http.get("/event/".concat(serviceId, "/?eventType=").concat(payload.eventType, "&startAt=").concat(payload.startAt, "&endAt=").concat(payload.endAt));

              case 2:
                result = _context.sent;
                return _context.abrupt("return", result.data);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getEventStats(_x, _x2) {
        return _getEventStats.apply(this, arguments);
      }

      return getEventStats;
    }()
  }, {
    key: "getServiceEvents",
    value: function () {
      var _getServiceEvents = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(serviceId) {
        var result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return http.get("/provider-service/".concat(serviceId, "/event-data"));

              case 2:
                result = _context2.sent;
                return _context2.abrupt("return", result.data);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getServiceEvents(_x3) {
        return _getServiceEvents.apply(this, arguments);
      }

      return getServiceEvents;
    }() //will fail if logged in user is not the service owner

  }, {
    key: "getServiceEventsForUser",
    value: function () {
      var _getServiceEventsForUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(serviceId, userId) {
        var limit,
            offset,
            result,
            _args3 = arguments;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                limit = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : 50;
                offset = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : 0;
                _context3.next = 4;
                return http.get("/provider-service/".concat(serviceId, "/event-data/").concat(userId, "?limit=").concat(limit, "&offset=").concat(offset));

              case 4:
                result = _context3.sent;
                return _context3.abrupt("return", result.data);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getServiceEventsForUser(_x4, _x5) {
        return _getServiceEventsForUser.apply(this, arguments);
      }

      return getServiceEventsForUser;
    }()
  }, {
    key: "getMetrics",
    value: function () {
      var _getMetrics = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var result;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return http.get('/metric');

              case 2:
                result = _context4.sent;
                return _context4.abrupt("return", result.data);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function getMetrics() {
        return _getMetrics.apply(this, arguments);
      }

      return getMetrics;
    }()
  }, {
    key: "getTopic",
    value: function () {
      var _getTopic = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return http.get("/topic/s/?topic=".concat(payload));

              case 2:
                result = _context5.sent;
                return _context5.abrupt("return", result.data);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function getTopic(_x6) {
        return _getTopic.apply(this, arguments);
      }

      return getTopic;
    }()
  }, {
    key: "getResources",
    value: function () {
      var _getResources = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(payload) {
        var result;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return http.get("/resource/?resourceType=".concat(payload.resourceType, "&modelIds[]=").concat(payload.modelIds));

              case 2:
                result = _context6.sent;
                return _context6.abrupt("return", result.data);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function getResources(_x7) {
        return _getResources.apply(this, arguments);
      }

      return getResources;
    }()
  }]);

  return AnalyticsService;
}();

var analyticsService = new AnalyticsService();
export default analyticsService;